
import { defineComponent } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/css';

import { MovieFilmComponentSetup } from '@/components/MovieFilmComponentBase';

export default defineComponent({
  name: 'PcMovieFilmComponent',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    bgDark: Boolean,
    listTitle: String,
    company: String,
    keyword: String,
    tagid: String,
  },
  setup(props) {
    return MovieFilmComponentSetup(props);
  }
});
